import { useState } from "react";
import { motion } from "framer-motion";
import FooterListTitle from "./FooterListTitle";
import { FaFacebook, FaGithub, FaInstagram, FaLinkedin, FaWhatsapp, FaYoutube } from "react-icons/fa";
import emailjs from "emailjs-com";
import { Bounce, toast, ToastContainer } from 'react-toastify';
export default function Footer() {
  const [subscription, setSubscription] = useState(false);
  const [emailInfo, setEmailInfo] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [showEnquiry, setShowEnquiry] = useState(false);
  const [enquiry, setEnquiry] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const handleSendEnquiry = (e) => {
    e.preventDefault();

    if (!enquiry.name || !enquiry.phone || !enquiry.email) {
      setErrMsg("Please fill in all fields");
      return;
    }

    const templateParams = {
      name: enquiry.name,
      phone: enquiry.phone,
      email: enquiry.email,
      message: enquiry.message || "No enquiry text provided",
    };

    emailjs
      .send(
        "service_na9v6kh",   // ✅ Your Service ID
        "template_lx7xin8",  // ✅ Your Template ID
        templateParams,
        "87kHi7NHT-9w8y36o"       // ✅ Your Public Key (User ID)
      )
      .then(
        (response) => {
          if (response?.status == 200) {
            toast('🦄 Enquiry sent successfully!', {
              position: "bottom-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              transition: Bounce,
            });
            setErrMsg("");
            setShowEnquiry(false);
            setEnquiry({
              name: "",
              phone: "",
              email: "",
              message: "",
            });
          }
        },
        (err) => {
          console.log("FAILED...", err);
          setErrMsg("Failed to send enquiry. Please try again.");
        }
      );
  };

  return (
    <div className="w-full bg-[#F5F5F3] py-20">
      <div className="max-w-container mx-auto flex flex-col xl:flex-row justify-between px-4 gap-10">
        {/* About Section */}
        <div className="xl:w-1/3">
          <FooterListTitle title="More about Heritage Harvest" />
          <p className="text-base w-full xl:w-[80%] mt-4">
            Pure spices from Idukki, Kerala. Premium cardamom, black pepper, and more to come.
          </p>
          <p>For Enquiry: <a href="tel:8606591509">8606591509</a></p>

          <ul className="flex items-center gap-2">
            <a href="https://www.facebook.com/share/16MduHRAf8/?mibextid=wwXIfr" target="_blank" rel="noreferrer">
              <li className="w-7 h-7 bg-primeColor text-gray-100 hover:text-white cursor-pointer text-lg rounded-full flex justify-center items-center hover:bg-black duration-300">
                <FaFacebook />
              </li>
            </a>
            <a href="https://www.instagram.com/heritage__harvest?igsh=aHRncHp3cnFjZWlw" target="_blank" rel="noreferrer">
              <li className="w-7 h-7 bg-primeColor text-gray-100 hover:text-white cursor-pointer text-lg rounded-full flex justify-center items-center hover:bg-black duration-300">
                <FaInstagram />
              </li>
            </a>
            <a
              href="https://wa.me/918606591509?text=Hello%20I%20want%20to%20enquire%20about%20your%20services"
              target="_blank"
              rel="noreferrer"
            >
              <li className="w-7 h-7 bg-primeColor text-gray-100 hover:text-white cursor-pointer text-lg rounded-full flex justify-center items-center hover:bg-black duration-300">
                <FaWhatsapp />
              </li>
            </a>

          </ul>
        </div>

        {/* Products Section */}
        <div className="xl:w-1/4">
          <FooterListTitle title="Our Products" />
          <ul className="flex flex-col gap-2 mt-4">
            <li className="cursor-pointer hover:underline">Cardamom</li>
            <li className="cursor-pointer hover:underline">Black Pepper</li>
            <li className="cursor-pointer hover:underline">More Spices Coming Soon</li>
          </ul>
        </div>

        {/* Enquiry Section */}
        <div className="xl:w-1/3 flex flex-col items-center w-full px-4">
          <FooterListTitle title="Contact with us" />
          <div className="w-full mt-4">
            <div className="w-full flex gap-4">
              <input
                type="text"
                value={enquiry.message}
                onChange={(e) => setEnquiry({ ...enquiry, message: e.target.value })}
                placeholder="Type your enquiry..."
                className="w-full h-12 border-b border-gray-400 bg-transparent px-4 text-primeColor text-lg placeholder:text-base outline-none"
              />
              <button
                onClick={() => setShowEnquiry(true)}
                className="bg-white text-gray-700 px-6 h-10 hover:bg-black hover:text-white duration-300 text-base tracking-wide shadow-md"
              >
                Send
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Enquiry Popout Modal */}
      {showEnquiry && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            className="bg-white p-6 rounded-2xl shadow-lg w-[90%] md:w-[400px]"
          >
            <h2 className="text-xl font-semibold text-primeColor mb-4">Enquiry Form</h2>
            <input
              type="text"
              placeholder="Your Name"
              value={enquiry.name}
              onChange={(e) => setEnquiry({ ...enquiry, name: e.target.value })}
              className="w-full mb-3 border-b border-gray-400 px-2 py-2 outline-none"
            />
            <input
              type="text"
              placeholder="Phone Number"
              value={enquiry.phone}
              onChange={(e) => setEnquiry({ ...enquiry, phone: e.target.value })}
              className="w-full mb-3 border-b border-gray-400 px-2 py-2 outline-none"
            />
            <input
              type="email"
              placeholder="Email Address"
              value={enquiry.email}
              onChange={(e) => setEnquiry({ ...enquiry, email: e.target.value })}
              className="w-full mb-3 border-b border-gray-400 px-2 py-2 outline-none"
            />
            {errMsg && <p className="text-red-600 text-sm mb-2">{errMsg}</p>}
            <div className="flex justify-end gap-4 mt-4">
              <button
                onClick={() => setShowEnquiry(false)}
                className="px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded"
              >
                Cancel
              </button>
              <button
                onClick={handleSendEnquiry}
                className="px-4 py-2 bg-primeColor text-white hover:bg-black rounded"
              >
                Send
              </button>
            </div>
          </motion.div>
        </div>
      )}
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
    </div>
  );
}
